import { render, staticRenderFns } from "./ServiceTypeTable.vue?vue&type=template&id=504307cd&"
import script from "./ServiceTypeTable.vue?vue&type=script&lang=js&"
export * from "./ServiceTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports